import { render, staticRenderFns } from "./InfoBus.vue?vue&type=template&id=743c599b"
import script from "./InfoBus.vue?vue&type=script&lang=js"
export * from "./InfoBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports